// extracted by mini-css-extract-plugin
export default {"sortableList":"sortable-list_sortableList__oup+O"};